import { Component, forwardRef, OnInit } from '@angular/core';
import { NG_VALIDATORS, NG_VALUE_ACCESSOR } from '@angular/forms';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ReceiptBookCategoryDto, ReceiptBookClient } from '../../api-connector/sso-connector';
import { BaseAutocompleteControl } from '../base-autocomplete-control';
import { AutocompleteCacheService } from '../../services/autocomplete-cache.service';

@Component({
  selector: 'app-receipt-book-category',
  templateUrl: './receipt-book-category.component.html',
  styleUrls: ['./receipt-book-category.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => ReceiptBookCategoryComponent),
      multi: true,
    },
    {
      provide: NG_VALIDATORS,
      useExisting: forwardRef(() => ReceiptBookCategoryComponent),
      multi: true,
    }
  ]
})
export class ReceiptBookCategoryComponent extends BaseAutocompleteControl<ReceiptBookCategoryDto> implements OnInit {

  constructor(
    private receiptBookClient: ReceiptBookClient,
    private cache: AutocompleteCacheService
  ) {
    super();
  }

  ngOnInit(): void {
    super.ngOnInit();
  }

  protected fetchItems(searchValue: string): Observable<ReceiptBookCategoryDto[]> {
    const cacheKey = `receipt_book_search_${searchValue}`;
    return this.cache.wrap(cacheKey, this.receiptBookClient.getReceiptBookCategory(searchValue).pipe(
      map(items => items || [])
    ));
  }

  getDisplayValue(item: ReceiptBookCategoryDto | null): string {
    return item?.name || '';
  }

  protected isValidItem(value: any): boolean {
    return value instanceof ReceiptBookCategoryDto;
  }
}
